import { DEFAULT_CITY } from '../../../shared/cities/index.ts';
import {
  nowcastText as nowcastTextIn,
  WEATHER_CONDITION_LABELS,
  type NowcastSummary,
} from '../../../shared/domain/index.ts';

/**
 * Les libellés vivent dans le domaine partagé : le Worker écrit le même texte dans le HTML servi aux robots.
 * Ces alias évitent de faire passer le fuseau de la ville à chaque appel dans l'interface.
 */
export const CONDITION_LABELS = WEATHER_CONDITION_LABELS;

export const nowcastText = (summary: NowcastSummary): string => nowcastTextIn(summary, DEFAULT_CITY.timeZone);
